import React, { useEffect, useRef, forwardRef, useImperativeHandle } from "react";

const Turnstile = forwardRef(({ sitekey, onVerify }, ref) => {
  const divRef = useRef();
  const widgetId = useRef(null);

  // Permite al componente padre usar métodos como .reset()
  useImperativeHandle(ref, () => ({
    reset: () => {
      if (widgetId.current !== null && window.turnstile) {
        window.turnstile.reset(widgetId.current);
      }
    },
  }));

  useEffect(() => {
    if (window.turnstile && divRef.current) {
      widgetId.current = window.turnstile.render(divRef.current, {
        sitekey,
        callback: onVerify,
        theme: "light",
      });

      return () => {
        if (widgetId.current !== null) {
          window.turnstile.remove(widgetId.current);
          widgetId.current = null;
        }
      };
    }
  }, [sitekey, onVerify]);

  return <div ref={divRef} className="cf-turnstile" />;
});

export default Turnstile;